<template>
    <Table
      :columns="cols"
      :data="tableData"
      :loading="loading"
      border
      :width="cols.reduce((a,v)=>a+v.width,0)+5"
      >
      <BaseLoading v-if="loading" />
      <div class="flex-wrap flex-right" style="font-size:12px;color:var(--subtext3)">

                  </div>
    </Table>
  </template>

<script>
export default {
  name: 'CmTableYearHrv',
  data() {
    return {
      tableData: [{
        dep: '公司',
      }, {
        dep: '建设管理事业部',
      }, {
        dep: '房建监理事业部',
      }, {
        dep: '市政监理事业部',
      }],
      loading: true,
    };
  },
  computed: {
    cols() {
      return [{
        key: 'dep',
        title: '部门',
        align: 'center',
        width: 200,
      }, {
        key: 'count',
        title: '总人数',
        align: 'center',
        width: 140,
      }, {
        key: 'plan_hrv',
        title: '计划总人年',
        align: 'center',
        width: 160,
      }, {
        key: 'predict_hrv',
        title: '预测总人年',
        align: 'center',
        width: 160,
      }, {
        key: 'current_hrv',
        title: '现实际总人年',
        align: 'center',
        width: 160,
      }, {
        key: 'remain_hrv',
        title: '剩余计划人年',
        align: 'center',
        width: 160,
      }, {
        key: 'raw_hrv',
        title: '人力资源手动统计',
        align: 'center',
        width: 160,
      }];
    },
  },
  mounted() {
    this.getData();
  },
  props: {
    year: {
      type: String | Number,
    },
  },
  methods: {
    getData() {
      this.loading = true;
      let url = 'cm/tables/hrv';
      url += '?year='+this.year;
      this.$api.get(url).then((res)=>{
        const result = res.data.data;
        this.tableData = result.data;
        this.created_at = result.created_at;
      }).finally(()=>{
        this.loading = false;
      });
    },
    exportExcel() {

    },
  },
};
</script>

  <style>

  </style>
